import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Permanent redirect. /tailor was the original path and is linked from older
 * shares and from search results, so it keeps working and passes its ranking
 * signals to the descriptive URL rather than 404ing.
 */
export const Route = createFileRoute("/tailor")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/resume-tailor", search, statusCode: 301 });
  },
});
